// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
// OnboardingProgressService  Handles the endpoints related to the onboarding progress functionality.
// The endpoints are implemented in the insys-onboarding service.
export const OnboardingProgressService = {
    // CreateOnboardingProgress store the onboarding progress made by the customer in the onboarding progress table
    CreateOnboardingProgress(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-progress/onboarding-progress/create`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetOnboardingProgress get information about onboarding progress made by the customer
    GetAllOnboardingProgressRecordsByLocationID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-progress/onboarding-progress?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // UpdateOnboardingProgress updates the onboarding progress made by the customer in the onboarding progress table
    UpdateOnboardingProgress(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-progress/onboarding-progress/update`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ResendUserInviteEmail resends the user invite email to customer
    ResendUserInviteEmail(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-progress/user-invite/resend`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetLatestOnboardingProgressByLocationID returns latest onboarding progress status for given locationID
    GetLatestOnboardingProgressByLocationID(fn, req) {
        return fn(`/insys/onboarding/v1/onboarding-progress/onboarding-progress/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // IsUserSetupCompleteByUserEmail returns true if a user has completed the user setup in the last 60 days
    IsUserSetupComplete(fn, req) {
        try {
            fm.validateUrlParam(req["userEmail"], "userEmail");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/insys/onboarding/v1/onboarding-progress/user-invite/status/${req["userEmail"]}?${fm.renderURLSearchParams(req, ["userEmail"])}`, { method: "GET" });
    },
};
